import React from "react";
import {Skeleton} from "@material-ui/lab";

class Unit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: props.isLoading
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.isLoading !== this.props.isLoading) {
            this.setState({isLoading: this.props.isLoading});
        }
    }

    render() {
        return (
            <div style={{height: 50, width: 80, borderRadius: 25, display: 'flex', flexDirection: 'column',
                justifyContent: 'center', alignItems: 'center', fontSize: 14,
                backgroundColor: this.props.name === "Cumulative" ? '#66D2FF' : '#99E1FF'}}>
                <div>{this.props.name}</div>
                <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    {
                        this.state.isLoading
                            ? <Skeleton variant={"rect"} width={15} height={17} style={{marginRight: 5}}/>
                            : <div style={{textAlign: 'center', height: 17, width: this.props.name === "Cumulative"
                                ? 20 : 15, marginRight: 5}}>
                                {this.props.unit}
                            </div>
                    }
                    <div>units</div>
                </div>
            </div>
        );
    }
}

export default Unit;